import { render, staticRenderFns } from "./EmployeeContactsDetail.vue?vue&type=template&id=834f136e&scoped=true&"
import script from "./EmployeeContactsDetail.vue?vue&type=script&lang=js&"
export * from "./EmployeeContactsDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "834f136e",
  null
  
)

export default component.exports